/** @jsx jsx */
import { jsx } from "@emotion/core"
import { IRecord } from "../../types/schema"
import { KeyValueList } from "../KeyValueList"
import { createHoverLoader } from "./createHoverLoader"
import { buildRoute, eRoutes } from "../../routes"
import { isFakeEmail } from "../../utils/email"

type IUser = IRecord<"skeem_users", "name" | "payrollNumber" | "skeem_email"> & {
  company: IRecord<"companies"> | null
}

export const HoverUserLoader = createHoverLoader<IUser>({
  model: "skeem_users",
  attributes: ["name", "payrollNumber", "skeem_email", "company"],
  Target({ record }) {
    return record.name
  },
  HoverContent({ record }) {
    return (
      <KeyValueList
        data={[
          { label: "Name", value: record.name },
          { label: "Unique Identifier", value: record.payrollNumber },
          { label: "Email", value: isFakeEmail(record.skeem_email) ? null : record.skeem_email },
        ]}
      />
    )
  },
  viewLink: (record, globalState) => {
    const companyId = record.company?.id ?? globalState.company?.id

    if (globalState.inAdminArea || window.location.href.includes("/companies")) {
      if (!companyId) {
        return null
      }
      return buildRoute(eRoutes["/companies/:companyId/users/:id"], {
        id: record.id,
        companyId,
      })
    }

    if (
      globalState.user.isManager ||
      globalState.user.isAdmin ||
      globalState.permissions.canManageEmployees
    ) {
      return buildRoute(eRoutes["/manager/users/:id"], { id: record.id })
    }

    return null
  },
})
